import React from "react";
import "./ModalApp.css";

function ModalApp({ onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ×
        </button>

        <div className="modal-avatar">😊</div>

        <h2>Disponible sur mobile</h2>

        <p>
          Notre application est disponible sur <strong>Play Store</strong> et{" "}
          <strong>App Store</strong>. Installez-la dès maintenant !
        </p>

        <div className="store-links">
          <a
            href="https://play.google.com/store/apps/details?id=com.dollarv4.myproject"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/play.png" alt="Disponible sur Play Store" />
          </a>

          <a
            href="https://apps.apple.com/app/dollar-store/id6766097301"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/app.png" alt="Disponible sur App Store" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default ModalApp;